import { Link } from 'react-router-dom';
import { Facebook, Instagram, Music2, Mail, Cookie } from 'lucide-react';
import { useLang } from '../i18n/LangContext';

const SOCIALS = [
  { icon: Facebook, label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61593083834119', testid: 'social-facebook' },
  { icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/krug_app', testid: 'social-instagram' },
  { icon: Music2, label: 'TikTok', href: 'https://www.tiktok.com/@krug.aplikacija', testid: 'social-tiktok' },
];

export const Footer = () => {
  const { t } = useLang();
  const FOOTER_NAV = t.footer.nav;
  const FOOTER_LEGAL = t.footer.legal;
  return (
  <footer data-testid="main-footer" className="bg-[#02060D] border-t border-white/10 pt-16 pb-10">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
        <div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white p-1">
              <img src="/assets/krug-logo.png" alt="KRUG logo" className="w-full h-full object-contain" />
            </span>
            <span className="font-heading font-extrabold tracking-[0.18em] text-xl text-white">KRUG</span>
          </div>
          <p className="mt-5 text-sm text-slate-400 max-w-xs leading-relaxed">
            {t.footer.tagline}
          </p>
          <p className="mt-2 text-sm text-krug-goldbright font-medium">{t.footer.slogan}</p>
          <a
            href="mailto:info@krug-app.eu"
            data-testid="footer-email"
            className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-krug-tealbright transition-colors duration-300"
          >
            <Mail size={15} />
            info@krug-app.eu
          </a>
          <div className="mt-7 flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={s.testid}
                aria-label={s.label}
                className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/12 text-slate-400 hover:text-krug-tealbright hover:border-krug-tealbright/50 transition-colors duration-300"
              >
                <s.icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="Navigacija">
          <h3 className="font-heading text-xs font-bold uppercase tracking-[0.25em] text-slate-500 mb-5">{t.footer.pagesTitle}</h3>
          <ul className="space-y-3">
            {FOOTER_NAV.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, '-')}`} className="text-sm text-slate-400 hover:text-white transition-colors duration-300">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Pravne informacije">
          <h3 className="font-heading text-xs font-bold uppercase tracking-[0.25em] text-slate-500 mb-5">{t.footer.infoTitle}</h3>
          <ul className="space-y-3">
            {FOOTER_LEGAL.map((l) => (
              <li key={l.href}>
                <Link to={l.href} data-testid={`footer-legal-${l.href.slice(1)}`} className="text-sm text-slate-400 hover:text-white transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="mt-14 pt-7 border-t border-white/8 flex flex-col md:flex-row items-center justify-between gap-3">
        <p data-testid="footer-copyright" className="text-xs text-slate-500">{t.footer.copyright}</p>
        <button
          type="button"
          data-testid="footer-cookie-settings"
          onClick={() => window.dispatchEvent(new Event('krug-cookie-settings'))}
          className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-krug-tealbright transition-colors duration-300"
        >
          <Cookie size={13} />
          {t.footer.cookie.settings}
        </button>
        <p data-testid="footer-publisher" className="text-xs text-slate-600">
          {t.footer.publisherLabel}: <span className="text-slate-400">Sandy Smajic Consulting</span>
        </p>
      </div>
    </div>
  </footer>
  );
};
